// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae6fd713","920":"4179250a"}[chunkId] + ".chunk.js";
};